// src/pages/PublicOrderPage.jsx
import React, { useCallback, useEffect, useRef, useState } from "react";
import axios from "axios";
import Swal from "sweetalert2";
import ItemCustomizeModal from "../../components/itemCustomizeModal";
import { getCurrencySymbol } from "../../libs/countryData";
import { Badge, Container, Table } from "react-bootstrap";
import OrderWaitingScreen from "../../components/orderingPage/orderedItems";

const apiBase = process.env.REACT_APP_API_URL;

const yoooo = axios.create({
  headers: { "Content-Type": "application/json" },
  paramsSerializer: (params) => {
    // Add a timestamp to all requests to bust CORS preflight cache
    return new URLSearchParams({
      ...params,
      _: Date.now().toString(), // Cache-busting query parameter
    }).toString();
  },
});


export default function PublicOrderPage({ tableId, menuId }) {
  const [loading, setLoading] = useState(true);
  const [tableInfo, setTableInfo] = useState({ id: tableId, label: "" });
  const [menuInfo, setMenuInfo] = useState({ id: menuId, name: "" });
  const [categories, setCategories] = useState([]);
  const [cart, setCart] = useState([]);
  const [customerName, setCustomerName] = useState("");
  const [activeItem, setActiveItem] = useState(null);
  const [showCartModal, setShowCartModal] = useState(false);

  const [error, setError] = useState(null);
  const [status, setStatus] = useState(null);
  const [tableSession, setTableSession] = useState(null);

  const sectionRefs = useRef({});

  useEffect(() => {
    loadMenu();
  }, [tableId, menuId]);

  const fetchData = useCallback(async () => {
    try {
      let params = { tableId, menuId };
      const orderRef = localStorage.getItem("orderRef");

      if(orderRef){
        params = {...params, orderRef};
      }
      const res = await yoooo.get(apiBase+"/api/myshop/public-menu", { params });
        
      if (res.data?.ok) {
        //check if served, show thanks screen and clear localstorage!
        if(res.data?.session?.status === "closed"){
          Swal.fire({
            title: 'Thank you!',
            text: "Your order is now billed out. Thank you for dining with us!",
            icon: 'success',
            confirmButtonText: 'Close window'
          }).then((result) => {
            if(result.isDismissed !== true || result.dismiss){
              window.location.href = "https://google.com";
            }
          });
          localStorage.removeItem("orderRef");
          localStorage.removeItem("cart");
          localStorage.removeItem("sure_order");
        }else{
          setTableSession(res.data?.session);
        }
      }
    } catch (error) {
        console.error('Polling failed:', error);
    } finally {
        setLoading(false);
    }
}, []); // Empty dependency array: fetchData never changes

  useEffect(() => {
    if(tableSession?.status && tableSession.status !== "closed"){
      const intervalId = setInterval(() => {
        fetchData();
      }, 15000); 

      return () => {
          clearInterval(intervalId);
      };
    }
  },[tableSession, fetchData])

  useEffect(() => {
    if(cart.length > 0){
      localStorage.setItem("cart",JSON.stringify(cart));
    }
  }, [cart]);

  async function loadMenu() {
    setError(null);
    setLoading(true);
    try {
      let params = { tableId, menuId };
      const orderRef = localStorage.getItem("orderRef");
      const _cart = localStorage.getItem("cart");

      if(_cart){
        setCart(JSON.parse(_cart));
      }

      if(orderRef){
        params = {...params, orderRef};
      }
      if(!localStorage.getItem("sure_order") && localStorage.getItem("sure_order") !=="yeah"){
        Swal.fire({
          title: 'Welcome!',
          text: "Do you want to start ordering?",
          icon: 'info',
          confirmButtonText: 'Yes',
          showCancelButton: true,
        }).then((result) => {
          if(result.isConfirmed){
            localStorage.setItem("sure_order", "yeah");
            window.location.reload();
          }else if(result.dismiss === Swal.DismissReason.cancel){
            window.location.href = "https://google.com";
          }
        });
      }else{
        const res = await yoooo.get(apiBase+"/api/myshop/public-menu", { params });
        if (!res.data?.ok) {
          Swal.fire("Menu unavailable", res.data?.error || "Cannot load menu", "warning");
          setTableInfo((prev) => ({
            ...prev,
            label: prev.label || `Table ${tableId}`,
          }));
        } else {
          //check if served, show thanks screen and clear localstorage!
          if(res.data?.session?.status === "closed"){
            Swal.fire({
              title: 'Thank you!',
              text: "Your order is now billed out. Thank you for dining with us!",
              icon: 'success',
              confirmButtonText: 'Close window'
            }).then((result) => {
              if(result.isDismissed !== true || result.dismiss){
                window.location.href = "https://google.com";
              }
            });
            localStorage.removeItem("orderRef");
            localStorage.removeItem("cart");
            localStorage.removeItem("sure_order");
          }else{
            if(res.data?.reset){
              localStorage.removeItem("orderRef");
              localStorage.setItem("reset-orderRef", "true");
              localStorage.removeItem("cart");
              localStorage.removeItem("sure_order");
              setTimeout(() => {
                window.location.replace("https://google.com");
                return;
              }, 500);
              return;
            }
            setStatus(res.data?.session?.status);
            setTableSession(res.data?.session);
            switch(res.data.session?.status){
              case "ordered":
                Swal.fire("Order sent!", "Please wait for staff to confirm.", "success");
              break;
              default:
                if(res.data?.table?.status === "vacant"){
                  if(localStorage.getItem("reset-orderRef") === "true"){
                    localStorage.removeItem("reset-orderRef");
                  }else{
                    localStorage.setItem("orderRef", res.data.orderRef);
                  }
                }else{
                  localStorage.setItem("orderRef", orderRef || res.data.orderRef);
                }
                setTableInfo(res.data.table || { id: tableId });
                setMenuInfo(res.data.menu || { id: menuId });
                setCategories(res.data.categories || []);
            }
          }
        }
      }

    } catch (err) {
      console.error(err);
      setError(err.response?.data?.error);
      switch(err.response?.data?.currentStatus){
        case "reserved":
          Swal.fire("Table is Reserved", "Is this table vacant? If you can't order, the table status may be incorrect due to an error or a held reservation. Please notify our staff to clear the status and allow you to order immediately.", "error");
          break;
        case "occupied_ordered":
        case "occupied_preparing_meal":
        case "occupied_served":
          Swal.fire("Table is Occupied", "Is this table vacant? If you can't order, the table status may be incorrect due to an error or a held reservation. Please notify our staff to clear the status and allow you to order immediately.", "error");
        break;
        default:
          Swal.fire("Error", "Failed to load menu", "error");
      }
      localStorage.removeItem("orderRef");
    } finally {
      setLoading(false);
    }
  }
  function MobileCartModal({ cart, onClose, onRemove, onQtyChange, total, onSubmit }) {
    return (
      <div
        className="d-lg-none"
        style={{
          position: "fixed",
          inset: 0,
          background: "rgba(0,0,0,0.45)",
          zIndex: 1000,
        }}
      >
        <div
          style={{
            position: "absolute",
            bottom: 0,
            left: 0,
            right: 0,
            background: "#fff",
            borderTopLeftRadius: "14px",
            borderTopRightRadius: "14px",
            maxHeight: "80vh",
            display: "flex",
            flexDirection: "column",
          }}
        >
          <div className="d-flex justify-content-between align-items-center p-2 border-bottom">
            <div style={{ fontWeight: 600 }}>Your Items</div>
            <button className="btn btn-sm btn-light" onClick={onClose}>
              Close
            </button>
          </div>
          <div style={{ flex: 1, overflowY: "auto" }}>
            {cart.length === 0 ? (
              <div className="p-3 text-muted" style={{ fontSize: "0.75rem" }}>
                Cart is empty.
              </div>
            ) : (
              cart.map((line, idx) => (
                <div key={idx} className="p-2 border-bottom">
                  <div style={{ fontWeight: 500 }}>{line.name}</div>
                  {(line.chosenModifiers || []).map((mg, i2) => (
                    <div key={i2} style={{ fontSize: "0.65rem", color: "#666" }}>
                      <b>{mg.groupName}:</b>{" "}
                      {(mg.selections || []).map((s) => s.name).join(", ")}
                    </div>
                  ))}
                  <div className="d-flex justify-content-between align-items-center mt-1">
                    <div className="input-group input-group-sm" style={{ width: "120px" }}>
                      <button
                        className="btn btn-outline-secondary"
                        onClick={() => onQtyChange(idx, Math.max(1, line.qty - 1))}
                      >
                        -
                      </button>
                      <input
                        className="form-control"
                        value={line.qty}
                        onChange={(e) =>
                          onQtyChange(idx, Math.max(1, Number(e.target.value) || 1))
                        }
                      />
                      <button
                        className="btn btn-outline-secondary"
                        onClick={() => onQtyChange(idx, line.qty + 1)}
                      >
                        +
                      </button>
                    </div>
                    <div>
                      <div style={{ fontWeight: 600 }}>
                        {getCurrencySymbol()}
                        {(
                          (line.basePrice || 0) +
                          (line.chosenModifiers || [])
                            .flatMap((g) => g.selections || [])
                            .reduce((s, v) => s + Number(v.priceDelta || 0), 0)
                        ) *
                          line.qty
                        }.00
                      </div>
                      <button
                        className="btn btn-link btn-sm p-0"
                        onClick={() => onRemove(idx)}
                      >
                        remove
                      </button>
                    </div>
                  </div>
                </div>
              ))
            )}
          </div>
          <div className="p-2 border-top">
            <div className="d-flex justify-content-between">
              <div>Total</div>
              <div style={{ fontWeight: 600 }}>{getCurrencySymbol()}{total.toFixed(2)}</div>
            </div>
            <button
              className="btn btn-success w-100 mt-2"
              disabled={cart.length === 0}
              onClick={onSubmit}
            >
              Send Order
            </button>
          </div>
        </div>
      </div>
    );
  }
  
  function addConfiguredItemToCart(line) {
    const sig = JSON.stringify(line.chosenModifiers || []);
    const idx = cart.findIndex(
      (c) => c.itemId === line.itemId && JSON.stringify(c.chosenModifiers || []) === sig
    );
    if (idx === -1) {
      setCart((prev) => [...prev, line]);
    } else {
      const clone = [...cart];
      clone[idx] = { ...clone[idx], qty: clone[idx].qty + line.qty };
      setCart(clone);
    }
  }

  function handleClickItem(item) {
    const hasMods = (item.modifierGroups || []).length > 0;
    if (!hasMods) {
      addConfiguredItemToCart({
        itemId: item._id,
        name: item.name,
        basePrice: Number(item.price || 0),
        chosenModifiers: [],
        qty: 1,
      });
      return;
    }
    setActiveItem(item);
  }

  function calcLineTotal(line) {
    const modsTotal = (line.chosenModifiers || [])
      .flatMap((g) => g.selections || [])
      .reduce((sum, s) => sum + Number(s.priceDelta || 0), 0);
    const unit = Number(line.basePrice || 0) + modsTotal;
    return unit * Number(line.qty || 0);
  }

  const cartTotal = cart.reduce((sum, line) => sum + calcLineTotal(line), 0);

  async function handleSubmit() {
    if (cart.length === 0) {
      Swal.fire("Your cart is empty", "", "info");
      return;
    }
    try {
      const payload = {
        tableId,
        menuId,
        customerName,
        items: cart.map((line) => ({
          itemId: line.itemId,
          qty: line.qty,
          chosenModifiers: line.chosenModifiers || [],
        })),
      };
      const res = await yoooo.post(apiBase  +"/api/myshop/public-order", payload);
      if (res.data?.ok) {
        localStorage.removeItem("cart");
        window.location.reload();
      } else {
        Swal.fire("Error", res.data?.error || "Order failed", "error");
      }
    } catch (err) {
      console.error(err);
      Swal.fire("Error", "Order failed", "error");
    }
  }

  function scrollToCategory(catId) {
    const el = sectionRefs.current[catId];
    if (el) el.scrollIntoView({ behavior: "smooth", block: "start" });
  }

  
  if (loading) {
    return (
      <div className="p-4 text-center">
        <div className="spinner-border" />
      </div>
    );
  }

  if (error) {
    return (
      <div className="p-4 text-center">
        {error}
      </div>
    );
  }

  if(status != null){
    return <>
      <OrderWaitingScreen tableSession={tableSession} />
    </>
  }

  return (
    <div className="public-order d-flex" style={{ minHeight: "100vh" }}>
      {/* DESKTOP category sidebar */}
      <aside
        className="d-none d-md-block"
        style={{
          width: "200px",
          borderRight: "1px solid #eee",
          padding: "1rem 0.5rem",
          background: "#fff",
        }}
      >
        <div style={{ fontSize: "0.7rem", color: "#777", marginBottom: "0.5rem" }}>
          Categories
        </div>
        <div className="d-flex flex-column gap-1">
          {categories.map((cat) => (
            <button
              key={cat.id}
              className="btn btn-sm btn-light text-start"
              onClick={() => scrollToCategory(cat.id)}
            >
              {cat.name}
            </button>
          ))}
        </div>
      </aside>

      {/* MAIN */}
      <main className="flex-grow-1" style={{ background: "#fafafa" }}>
        {/* TOP INFO */}
        <div
          style={{
            background: "#fff",
            borderBottom: "1px solid #eee",
            padding: "1rem 1.25rem 0.5rem",
            position: "sticky",
            top: 0,
            zIndex: 50,
          }}
        >
          <div style={{ fontSize: "0.65rem", color: "#888" }}>
            Ordering for {tableInfo.label || `Table ${tableId}`}
          </div>
          <div style={{ fontSize: "1.1rem", fontWeight: 600 }}>
            {menuInfo?.name || "Menu"}
          </div>
          <div className="mt-2" style={{ maxWidth: "280px" }}>
            <input
              className="form-control form-control-sm"
              value={customerName}
              onChange={(e) => setCustomerName(e.target.value)}
              placeholder="Your name / Group name (optional)"
            />
          </div>
        </div>

        {/* MOBILE floating categories */}
        <div
          className="d-md-none"
          style={{
            position: "sticky",
            top: 72,
            zIndex: 45,
            background: "#fafafa",
            padding: "0.4rem 0.5rem 0.4rem 0.75rem",
            overflowX: "auto",
            whiteSpace: "nowrap",
          }}
        >
          {categories.map((cat) => (
            <button
              key={cat.id}
              className="btn btn-sm btn-outline-dark me-2"
              style={{ borderRadius: "999px", fontSize: "0.7rem" }}
              onClick={() => scrollToCategory(cat.id)}
            >
              {cat.name}
            </button>
          ))}
        </div>

        {/* CONTENT */}
        <div className="p-3">
          {categories.map((cat, catIdx) => (
            <div
              key={cat.id}
              ref={(el) => (sectionRefs.current[cat.id] = el)}
              className="mb-4"
            >
              <div className="d-flex align-items-center gap-2 mb-1">
                {/* {catIdx === 0 ? (
                  <span style={{ fontSize: "1.2rem" }}>🔥</span>
                ) : null} */}
                <div style={{ fontWeight: 600, fontSize: "1rem" }}>{cat.name}</div>
              </div>
              {cat.subtitle ? (
                <div style={{ fontSize: "0.7rem", color: "#666", marginBottom: "0.5rem" }}>
                  {cat.subtitle}
                </div>
              ) : null}

              <div className="row g-2">
                {(cat.items || []).map((it) => (
                  <div key={it._id} className="col-12 col-sm-6 col-lg-4">
                    <div
                      className="card flex-row align-items-stretch"
                      style={{ cursor: "pointer", minHeight: "120px" }}
                      onClick={() => handleClickItem(it)}
                    >
                      {it.imageUrl ? (
                        <div
                          style={{
                            width: "100px",
                            minHeight: "100px",
                            background: "#f3f3f3",
                          }}
                        >
                          <img
                            src={it.imageUrl}
                            alt={it.name}
                            style={{ width: "100%", height: "100%", objectFit: "cover" }}
                          />
                        </div>
                      ) : null}
                      <div className="card-body py-2">
                        <div style={{ fontWeight: 600, fontSize: "0.9rem" }}>
                          {it.name}
                        </div>
                        {it.description ? (
                          <div style={{ fontSize: "0.7rem", color: "#666" }}>
                            {it.description}
                          </div>
                        ) : null}
                        <div style={{ fontWeight: 600, fontSize: "0.8rem", marginTop: "0.35rem" }}>
                          {getCurrencySymbol()}{Number(it.price || 0).toFixed(2)}
                        </div>
                        {(it.modifierGroups || []).length > 0 && (
                          <div style={{ fontSize: "0.6rem", color: "#c47f00" }}>
                            has options
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                ))}
                {(!cat.items || cat.items.length === 0) && (
                  <div style={{ fontSize: "0.7rem", color: "#999" }}>
                    No items in this category.
                  </div>
                )}
              </div>
            </div>
          ))}
          <div style={{ height: "80px" }} />
        </div>
      </main>

      {/* DESKTOP CART */}
      <aside
        className="d-none d-lg-flex flex-column"
        style={{
          width: "300px",
          borderLeft: "1px solid #eee",
          background: "#fff",
        }}
      >
        <div className="p-3 border-bottom">
          <div style={{ fontWeight: 600 }}>Table #{tableInfo.label || tableId}</div>
          <div style={{ fontSize: "0.7rem", color: "#666" }}>Your Items</div>
        </div>
        <div style={{ flex: 1, overflowY: "auto" }}>
          {cart.length === 0 ? (
            <div className="p-3 text-muted" style={{ fontSize: "0.75rem" }}>
              No items yet.
            </div>
          ) : (
            cart.map((line, idx) => (
              <div key={idx} className="p-2 border-bottom d-flex justify-content-between">
                <div>
                  <div style={{ fontWeight: 500 }}>{line.name}</div>
                  {(line.chosenModifiers || []).map((mg, i2) => (
                    <div key={i2} style={{ fontSize: "0.65rem", color: "#666" }}>
                      <b>{mg.groupName}:</b>{" "}
                      {(mg.selections || []).map((s) => s.name).join(", ")}
                    </div>
                  ))}
                  <div style={{ fontSize: "0.65rem", color: "#999" }}>Qty: {line.qty}</div>
                </div>
                <div style={{ textAlign: "right" }}>
                  <div style={{ fontWeight: 600 }}>
                    {getCurrencySymbol()}{calcLineTotal(line).toFixed(2)}
                  </div>
                  <button
                    className="btn btn-link btn-sm p-0"
                    onClick={() => setCart((prev) => prev.filter((_, i) => i !== idx))}
                  >
                    remove
                  </button>
                </div>
              </div>
            ))
          )}
        </div>
        <div className="p-3 border-top">
          <div className="d-flex justify-content-between mb-1">
            <div>Subtotal</div>
            <div>{getCurrencySymbol()}{cartTotal.toFixed(2)}</div>
          </div>
          <button
            className="btn btn-info w-100"
            disabled={cart.length === 0}
            onClick={handleSubmit}
          >
            Proceed to payment / order
          </button>
        </div>
      </aside>

      {/* MOBILE CART */}
      <div
        className="d-lg-none"
        style={{
          position: "fixed",
          bottom: 0,
          left: 0,
          right: 0,
          background: "#fff",
          borderTop: "1px solid #eee",
          padding: "0.4rem 0.75rem",
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <div>
          <div style={{ fontSize: "0.7rem", color: "#666" }}>Total</div>
          <div style={{ fontWeight: 600 }}>{getCurrencySymbol()}{cartTotal.toFixed(2)}</div>
        </div>
        <button
          className="btn btn-success btn-sm"
          disabled={cart.length === 0}
          onClick={handleSubmit}
        >
          Send Order ({cart.length})
        </button>
      </div>

      {activeItem && (
        <ItemCustomizeModal
          item={activeItem}
          onClose={() => setActiveItem(null)}
          onConfirm={(configuredLine) => {
            addConfiguredItemToCart(configuredLine);
            setActiveItem(null);
          }}
        />
      )}

    {showCartModal && (
      <MobileCartModal
        cart={cart}
        total={cartTotal}
        onClose={() => setShowCartModal(false)}
        onRemove={(idx) => setCart((prev) => prev.filter((_, i) => i !== idx))}
        onQtyChange={(idx, newQty) =>
          setCart((prev) => {
            const clone = [...prev];
            clone[idx] = { ...clone[idx], qty: newQty };
            return clone;
          })
        }
        onSubmit={() => {
          setShowCartModal(false);
          handleSubmit();
        }}
      />
    )}

    {/* MOBILE floating cart button (over content) */}
    {cart.length > 0 && (
      <button
        className="d-lg-none"
        style={{
          position: "fixed",
          right: "14px",
          bottom: "70px", // above bottom bar
          zIndex: 999,
          background: "#0d6efd",
          color: "#fff",
          border: "none",
          borderRadius: "999px",
          padding: "0.45rem 0.9rem",
          display: "flex",
          alignItems: "center",
          gap: "6px",
          boxShadow: "0 4px 12px rgba(0,0,0,.25)",
        }}
        onClick={() => setShowCartModal(true)}
      >
        <span>Proceed to order</span>
        <span style={{ background: "rgba(255,255,255,.15)", borderRadius: "999px", padding: "0 6px" }}>
          {cart.length}
        </span>
        <span>{getCurrencySymbol()}{cartTotal.toFixed(0)}</span>
      </button>
    )}

    </div>
  );
}
